import { EuiAvatar, EuiContextMenu, EuiFlexItem, EuiHeaderLink, EuiHeaderSectionItem, EuiHeaderSectionItemButton, EuiIcon, EuiPopover } from "@elastic/eui";
import React, { useState } from "react";
import {version} from '../../../../../package.json';


export const LinkUser = (props:any) =>{

    let {user, handleExit, exitParams}=props;
    const [isOpen, setIsOpen] = useState(false);
  
    const onMenuButtonClick = () => {
      setIsOpen(!isOpen);
    };
  
    const closeMenu = () => {
      setIsOpen(false);
    };
  
    const getItems = [{
        id: 0,
        // title: 'View options',
        items: [
          {
            name: <p>{`${'Versión'} ${version}`}</p>,
            icon: <EuiIcon type="iInCircle" size="m" />,
            disabled: true,
            className:"versionTag",
            onClick: () => {}
          },
          {
            name: 'Cerrar Sesión',
            icon: <EuiIcon type="push" size="m" />,
            onClick: () => {
              handleExit && handleExit('',exitParams)
            }
          }
        ]
      }];
  
    const perfil = (
      <EuiHeaderSectionItem className="profileUserMenu">
        <EuiAvatar color="#ff7e62" size="m" type="user" name={user && user.perfil} initialsLength={2}/>
      </EuiHeaderSectionItem>
    )
  
    const button = (
      <EuiHeaderSectionItemButton
        aria-expanded={isOpen}
        aria-haspopup="true"
        onClick={onMenuButtonClick}
        >
        <EuiHeaderLink className="userButtonMenu">
          <EuiFlexItem>
            {(user && user.nombre) || "USER"}{perfil}
          </EuiFlexItem>
        </EuiHeaderLink>
      </EuiHeaderSectionItemButton>
    );
    
    return(
      <EuiPopover
        id={user && user.nombre}
        ownFocus
        button={button}
        isOpen={isOpen}
        anchorPosition="downRight"
        panelStyle={{padding: "1px"}}
        closePopover={closeMenu}>
        <EuiContextMenu initialPanelId={0} panels={getItems}/>
      </EuiPopover>
    )
  }